import type { FC } from 'react';

interface VideoEmbedProps {
  url: string;
  title: string;
  className?: string;
}
export const VideoEmbed: FC<VideoEmbedProps> = ({ url, title, className }) => (
  <iframe
    className={className}
    loading="lazy"
    width="100%"
    height="480"
    src={url}
    frameBorder="0"
    title={title}
  />
);
